import AbsModule from '../common/AbsModule';
import PlatformDownload from '../components/PlatformDownload';

export default class GameStart extends AbsModule {
    constructor(_config, _isShow) {
        super(_config);

        this.isShow = _isShow;

        const { useGameStart, platformDownload } = this.moduleData;
        if(useGameStart === 'platformDownload' && Array.isArray(platformDownload)) {
            this._platformDownload = new PlatformDownload({ 
                data: this.moduleData, 
                l10nData: this.com.l10nData
            });
        }
    }

    makeMarkup() {
        const { useGameStart, gameStart, mobileGameDown } = this.moduleData;
        let tmpl = '';

        if (useGameStart === 'gameStart') {
            tmpl = `<div class="ncc-gamestart-btn">${gameStart.markUp}</div>`;
        } else if (useGameStart === 'mobileGameDown') {
            tmpl = `
            <div class="ncc-gamestart-app">
                ${mobileGameDown.showAndro? `
                <a href="${mobileGameDown.androAppLink}" class="android"><span>android downlaod</span></a>
                `: ''}
                ${mobileGameDown.showIos? `
                <a href="${mobileGameDown.iosAppLink}" class="ios"><span>ios downlaod</span></a>
                `: ''}
            </div>`;
        } else if (useGameStart === 'platformDownload' && this._platformDownload) {
            tmpl = this._platformDownload.makeMarkup();
        }
        return `<div class="ncc-gamestart">${tmpl}</div>`;
    }

    startSetting() {
        if(this._platformDownload) {
            this._platformDownload.startSetting();
        }
    }

    // 플랫폼 다운로드 레이어 노출/숨김
    platformLayerActive(isActive = false) {
        this._platformDownload.platformLayerActive(isActive);
    }
}